(function () {
    if (jQuery) {
        jQuery(document).ready(function ($) {
            $('.mobile-hamburger').click(function () {
                $('body').toggleClass('show-mobile-menu');
            });
        });
    }
})();
